export default () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/1x0dcqKwv74"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  );
}